import { Icon } from '@getpay93/ui';
import { PublicNav } from './PublicNav';
import { PublicFooter } from './PublicFooter';

const gratis = ['Hasta 10 clientes activos', 'Cobranza manual', 'Recordatorios por email', 'Comprobantes de pago'];
const pro = ['Clientes ilimitados', 'Reportes con export CSV/PDF', 'Recordatorios WhatsApp', 'Soporte prioritario'];
const faq: Array<{ q: string; a: string }> = [
  { q: '¿Qué cuenta como cliente activo?', a: 'Un cliente con al menos un cobro o membresía vigente en el mes.' },
  { q: '¿Puedo cambiar de plan?', a: 'Sí, cuando quieras. El equipo te ayuda con el upgrade.' },
  { q: '¿Cómo pagan mis clientes?', a: 'Con transferencia, efectivo o link de pago; suben su comprobante y tú lo apruebas.' },
  { q: '¿Hay permanencia?', a: 'No. Cancelas cuando quieras.' },
];

function Feat({ text }: { text: string }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '5px 0', fontSize: 14, fontWeight: 600, color: 'var(--text-body)' }}>
      <span style={{ color: 'var(--brand-green)', display: 'inline-flex' }}><Icon name="check" size={16} /></span>{text}
    </div>
  );
}

export function Precios() {
  return (
    <div className="gp-light" style={{ minHeight: '100vh', background: 'var(--bg)', fontFamily: 'var(--font-sans)' }}>
      <PublicNav />
      <div style={{ maxWidth: 940, margin: '0 auto', padding: '48px 24px', textAlign: 'center', boxSizing: 'border-box' }}>
        <h1 style={{ fontSize: 40, fontWeight: 800, letterSpacing: '-0.02em', color: 'var(--text-strong)', margin: '0 0 8px' }}>Precios simples</h1>
        <p style={{ fontSize: 17, fontWeight: 500, color: 'var(--text-muted)', margin: '0 0 36px' }}>Empieza gratis. Mejora cuando crezcas.</p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, textAlign: 'left', maxWidth: 720, margin: '0 auto' }}>
          <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, padding: 24, boxShadow: 'var(--shadow-light-card)' }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-strong)' }}>Gratis</div>
            <div style={{ fontSize: 34, fontWeight: 800, color: 'var(--text-strong)', margin: '8px 0 16px' }}>$0</div>
            {gratis.map((f) => <Feat key={f} text={f} />)}
            <a href="/registro" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 52, border: '1.5px solid var(--border-strong)', color: 'var(--text-body)', borderRadius: 12, fontSize: 16, fontWeight: 800, textDecoration: 'none', marginTop: 16 }}>Crear cuenta</a>
          </div>

          <div style={{ background: 'var(--surface)', border: '1.5px solid var(--brand-green)', borderRadius: 16, padding: 24, boxShadow: 'var(--shadow-light-card)', position: 'relative' }}>
            <span style={{ position: 'absolute', top: 16, right: 16, display: 'inline-flex', padding: '4px 10px', borderRadius: 999, background: 'var(--status-paid-bg)', color: 'var(--status-paid)', fontSize: 12, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase' }}>Recomendado</span>
            <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-strong)' }}>Pro</div>
            <div style={{ fontSize: 34, fontWeight: 800, color: 'var(--brand-green)', margin: '8px 0 16px' }}>Escríbenos</div>
            {pro.map((f) => <Feat key={f} text={f} />)}
            <a href="mailto:hola@getpay93.com?subject=Quiero%20GetPay93%20Pro" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 52, background: 'var(--brand-green)', color: '#FFFFFF', borderRadius: 12, fontSize: 16, fontWeight: 800, textDecoration: 'none', marginTop: 16 }}>Escríbenos</a>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center', background: 'var(--surface-2)', borderRadius: 12, padding: '14px 20px', margin: '28px auto', maxWidth: 720 }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-body)' }}>¿Quieres probarlo todo gratis por tiempo limitado? Escríbenos sobre el programa piloto.</span>
        </div>

        <div style={{ maxWidth: 720, margin: '0 auto', textAlign: 'left' }}>
          <h2 style={{ fontSize: 20, fontWeight: 800, color: 'var(--text-strong)', margin: '0 0 12px' }}>Preguntas frecuentes</h2>
          {faq.map((item) => (
            <div key={item.q} style={{ padding: '14px 0', borderTop: '1px solid var(--border)' }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-strong)' }}>{item.q}</div>
              <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-muted)', marginTop: 4 }}>{item.a}</div>
            </div>
          ))}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
